import { render, staticRenderFns } from "./PersonBasicInfoView.vue?vue&type=template&id=07abda48&scoped=true"
import script from "./PersonBasicInfoView.vue?vue&type=script&lang=js"
export * from "./PersonBasicInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07abda48",
  null
  
)

export default component.exports